import { BasketMarketOfferEntity } from '@genial/services';
import { Utils } from '@genial/utils';

import { messageError } from '../constants';

import { baseNormalization, normalizeCustomerBasketOffersData } from '.';

const getFundsBuyingDetails = (
  item: ReturnType<typeof normalizeCustomerBasketOffersData>[number]
) => {
  return [
    {
      label: 'Últimos 12 meses',
      value: Utils.Mask.Percentage(item.offer.profitabilityTwelveMonthsAdjusted) ?? messageError,
      type:
        item.offer.profitabilityTwelveMonthsAdjusted &&
        item.offer.profitabilityTwelveMonthsAdjusted > 0 &&
        'positive',
    },
    {
      label: item.offer.riskRatingName ?? messageError,
      value: item.offer.riskRatingLevel ?? messageError,
      type: 'risk',
    },
    {
      label: 'Cotização',
      value: item.offer.quotationRedemptionTermFormatted ?? messageError,
    },
  ];
};

const getFundsSellingDetails = (
  item: ReturnType<typeof normalizeCustomerBasketOffersData>[number]
) => {
  const offerRequestedDateQuotation = item?.offer?.requestedDateQuotation;
  const hasSelectedDate =
    item?.schedule?.scheduleDate &&
    offerRequestedDateQuotation?.liquidityDate &&
    offerRequestedDateQuotation?.movimentDate &&
    offerRequestedDateQuotation?.quotationDate;

  const quotation = hasSelectedDate
    ? offerRequestedDateQuotation.quotationDate
    : item.offer.quotationDate;
  const liquidity = hasSelectedDate
    ? offerRequestedDateQuotation.liquidityDate
    : item.offer.initialRedemptionDate;

  return [
    {
      label: 'Valor bruto solicitado',
      value: item.requestedAmountFormatted,
    },
    {
      label: 'Data cotização',
      value: quotation ? Utils.Mask.DateFormat(quotation, 'dd/MM/yyyy') : messageError,
    },
    {
      label: 'Previsão de liquidação*:',
      value: liquidity ? Utils.Mask.DateFormat(liquidity, 'dd/MM/yyyy') : messageError,
    },
  ];
};

export const normalizeCustomerBasketOffersFund = (data?: BasketMarketOfferEntity[]) => {
  if (!data) {
    return [];
  }

  const fundData = data.find((item) => item.marketType === 'Fund');

  if (!fundData) {
    return [];
  }

  const fundNormalizedData = normalizeCustomerBasketOffersData(fundData?.basketOffers);

  return fundNormalizedData.map((item) => ({
    ...baseNormalization(item),
    type: fundData.marketTypeTranslated || messageError,
    title: item.offer.productDisplay,
    productCategory: item.offer.productCategory || item.offer.category || 'Fundos',
    details:
      item.operationType === 'buy' ? getFundsBuyingDetails(item) : getFundsSellingDetails(item),
    total: {
      label: item.operationType === 'buy' ? 'Valor da aplicação' : 'Valor do resgate',
      description: item.operationType === 'buy' ? '' : 'Valor liquido',
      value: item.requestedAmountFormatted,
    },
  }));
};
